import { createStore, applyMiddleware } from "redux";
import rootReducer from "./reducers";
import axios from 'axios';
import axiosMiddleware from 'redux-axios-middleware';
import { message } from 'antd';
import Cookies from 'js-cookie';
import Config from '../Config';
import { setConfig } from './actions';

const config = new Config();

const client = axios.create({ //all axios can be used, shown in axios documentation
  baseURL: config.get_server_url(),
  responseType: 'json'
});

export const apiClient = client;

const store = createStore(
	rootReducer,
	applyMiddleware(
		axiosMiddleware(client)
	)
);

// Sesi habis (token expired/dicabut) saat sedang login → paksa logout & redirect ke /auth.
// Tidak menyentuh kegagalan login (status isLogin masih false) maupun network error,
// supaya tidak salah-trigger saat user salah memasukkan username/password atau backend down.
let isHandlingSessionExpired = false;
function handleSessionExpired() {
	if (isHandlingSessionExpired) return;
	isHandlingSessionExpired = true;

	Cookies.remove(config.get_cookie_name());
	Cookies.remove(config.get_cookie_name() + "_upt");
	Cookies.remove(config.get_cookie_name() + "_isNotice");
	Cookies.remove(config.get_cookie_name() + "_username");
	Cookies.remove(config.get_cookie_name() + "_expiry");
	Cookies.remove(config.get_cookie_name() + "_refresh");

	store.dispatch(setConfig({
		uptDipilih: "",
		isLogin: false,
		username: '',
		nama: '',
		id: '',
		pp: '',
		alamat: '',
		no_hp: '',
		layanan_id: [],
		layanan_str: [],
	}));

	message.error({ content: 'Sesi anda telah berakhir, silakan login kembali', duration: 5, key: 'toast' });

	setTimeout(() => {
		isHandlingSessionExpired = false;
	}, 3000);
}

// Access token sekarang berumur pendek (lihat samsat/settings.py SIMPLE_JWT) dan
// diperpanjang diam-diam oleh LayananRoute.js selama ada aktivitas - tapi kalau
// sebuah request kebetulan lewat persis saat token itu baru expired (di sela
// jadwal refresh proaktif), coba refresh SEKALI di sini dan ulangi request-nya,
// sebelum benar-benar dianggap sesi habis. Request bersamaan yang sama-sama
// kena 401 berbagi satu proses refresh yang sama (tidak masing-masing memanggil
// endpoint refresh sendiri-sendiri).
let refreshPromise = null;
export function getRefreshedAccessToken() {
	if (refreshPromise) return refreshPromise;

	const refreshToken = Cookies.get(config.get_cookie_name() + "_refresh");
	if (!refreshToken) {
		return Promise.reject(new Error('Tidak ada refresh token tersimpan'));
	}

	refreshPromise = client.post('api/token/refresh/', { refresh: refreshToken })
		.then((res) => {
			const newAccess = res.data && res.data.access;
			if (!newAccess) throw new Error('Respons refresh token tidak berisi access token');
			Cookies.set(config.get_cookie_name(), 'Bearer ' + newAccess, { expires: new Date(Date.now() + 30 * 60 * 1000) });
			return newAccess;
		})
		.finally(() => {
			refreshPromise = null;
		});

	return refreshPromise;
}

client.interceptors.response.use(
	(response) => response,
	(error) => {
		const response = error && error.response;
		const originalRequest = error && error.config;

		if (response) {
			const status = response.status;
			const detail = response.data && response.data.detail;
			const isAuthExpired = status === 401 || detail === 'Data autentikasi tidak diberikan.';
			const isTokenEndpoint = originalRequest && originalRequest.url && originalRequest.url.includes('api/token/');

			if (
				isAuthExpired &&
				!isTokenEndpoint &&
				originalRequest &&
				!originalRequest._retriedAfterRefresh &&
				store.getState().configReducers.isLogin
			) {
				originalRequest._retriedAfterRefresh = true;
				return getRefreshedAccessToken()
					.then((newAccess) => {
						originalRequest.headers = originalRequest.headers || {};
						originalRequest.headers.Authorization = 'Bearer ' + newAccess;
						return client(originalRequest);
					})
					.catch(() => {
						handleSessionExpired();
						return Promise.reject(error);
					});
			}

			if (isAuthExpired && store.getState().configReducers.isLogin) {
				handleSessionExpired();
			}
		}

		return Promise.reject(error);
	}
);

export default store;
